import { Document, Types } from 'mongoose';
import status from '../../Labour/constant/status.json'


export const AllocationRequestStatusEnum = {
    ACCEPTED: status.AllocationRequestStatus.ACCEPTED.toLowerCase(),
    REJECTED: status.AllocationRequestStatus.REJECTED.toLowerCase(),
    PENDING: status.AllocationRequestStatus.PENDING.toLowerCase(),
} as const;

export type AllocationRequestStatus = typeof AllocationRequestStatusEnum[keyof typeof AllocationRequestStatusEnum];



export interface IAllocationRequest extends Document {
    userId: Types.ObjectId;
    requestDate: Date;
    message?: string;
    allocationNotes?: string
    startDate: Date;
    endDate: Date;
    // location: string;
    wage: number;
    status: AllocationRequestStatus;
    responseNotes?: string;
    respondedAt?: Date;
    createdBy: Types.ObjectId;
    updatedBy?: Types.ObjectId;
    isDeleted: boolean;
    deletedAt?: Date;
    updatedAt?: Date;
    // companyName?: string
    userIds?: Types.ObjectId[]
    jobId: Types.ObjectId
}

